// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/submission_management_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SubmissionManagementService } from "./submission_management_service_pb";

/**
 * GetSubmissionDashboard returns, for the target date, every area that has
 * a demand-procurement plan record registered and the plan-type cards
 * valid in that area on that date. When feature_enabled is false the
 * frontend shows the under-development placeholder and areas is empty.
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.GetSubmissionDashboard
 */
export const getSubmissionDashboard = SubmissionManagementService.method.getSubmissionDashboard;

/**
 * GetPlanCounterpartyMismatch returns, for the plan the given plan
 * submission version belongs to, whether it has an unresolved
 * counterparty mismatch (show the 「取引相手間不整合解消」 button only when
 * has_unresolved), the counterparties for the confirmation dialog, and the
 * token ResolvePlanCounterpartyMismatch must echo. When feature_enabled is
 * false the button is not shown.
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.GetPlanCounterpartyMismatch
 */
export const getPlanCounterpartyMismatch = SubmissionManagementService.method.getPlanCounterpartyMismatch;

/**
 * ResolvePlanCounterpartyMismatch records the plan's unresolved
 * counterparty mismatches as resolved by the current member. STALE means
 * nothing was recorded because the list changed: re-read and show the
 * latest list. Never retried automatically (docs/specs/conventions.md).
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.ResolvePlanCounterpartyMismatch
 */
export const resolvePlanCounterpartyMismatch = SubmissionManagementService.method.resolvePlanCounterpartyMismatch;

/**
 * ListPlanHandlingMemos returns the 対応メモ history of the plan the given
 * plan submission version belongs to (AC-PSM-068), posted_at ascending
 * then id ascending. When feature_enabled is false the panel is not shown.
 * NOT_FOUND when the plan submission does not exist in the current
 * organization (flag on).
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.ListPlanHandlingMemos
 */
export const listPlanHandlingMemos = SubmissionManagementService.method.listPlanHandlingMemos;

/**
 * RecordPlanHandlingMemo appends a 対応メモ posted by the current member
 * (AC-PSM-057). It never resolves the counterparty mismatch (AC-PSM-058).
 * INVALID_ARGUMENT (no ErrorInfo) when the body is empty after trimming
 * the surrounding white space, longer than 100 code points or contains
 * NUL, or memo_id
 * is the nil UUID. FAILED_PRECONDITION when the flag is off; NOT_FOUND
 * when the plan submission does not exist in the current organization;
 * ALREADY_EXISTS when memo_id is stored with another plan, body or
 * poster. Never retried automatically (docs/specs/conventions.md); a
 * manual retry resends the same memo_id. There is no update or delete RPC
 * (AC-PSM-061).
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.RecordPlanHandlingMemo
 */
export const recordPlanHandlingMemo = SubmissionManagementService.method.recordPlanHandlingMemo;

/**
 * GetNoSubmissionRecordPlan returns the plan the business key names when it
 * has no eBalance version and shows an unmatched inconsistency notice
 * (AC-PSM-078): the counterparty × 48-koma values OCCTO holds, taken from
 * the adopted (latest) notice, for the read-only plan detail
 * (procurement-plan-detail.md AC-PPD-028). When the key's plan has a
 * representative version (the one the 取引先カード links to) it returns that
 * version's id instead, so the caller opens the version detail
 * (AC-PPD-029). When feature_enabled is false no result is set.
 * NOT_FOUND when the key has neither a version nor a displayed unmatched
 * notice in the current organization; INTERNAL when the adopted notice
 * cannot be shown as a table (a non-integer value, or a JEPX スポット 調達
 * row whose name maps to no portion).
 *
 * @generated from rpc bffuser.v1.SubmissionManagementService.GetNoSubmissionRecordPlan
 */
export const getNoSubmissionRecordPlan = SubmissionManagementService.method.getNoSubmissionRecordPlan;
